(function () {
  // Run on every product page
  if (window.location.pathname.indexOf('/products/') === -1) return;

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    try {
      // Already done? Stop.
      if (document.querySelector('.zurit-btn-row')) {
        clearInterval(timer);
        return;
      }

      // Quote button: find by class (stable even if the label changes)
      var quoteBtn = document.querySelector('.mprfq-add-to-quote-button-pdp');

      // Wholesale enquiry button: find by text
      var wholesaleBtn = null;
      var candidates = document.querySelectorAll('button, a, input[type="button"], input[type="submit"]');
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i] === quoteBtn) continue; // never match the quote button itself
        var txt = ((candidates[i].textContent || '') + ' ' + (candidates[i].value || '')).toLowerCase();
        if (txt.indexOf('wholesale enquiry') !== -1) {
          wholesaleBtn = candidates[i];
          break;
        }
      }

      if (quoteBtn && wholesaleBtn) {
        clearInterval(timer);

        var row = document.createElement('div');
        row.className = 'zurit-btn-row';
        wholesaleBtn.parentNode.insertBefore(row, wholesaleBtn);
        row.appendChild(wholesaleBtn);
        row.appendChild(quoteBtn);
      }
    } catch (e) {
      clearInterval(timer);
      console.error('Reorder script error:', e);
    }

    if (tries > 40) clearInterval(timer);
  }, 250);
})();